import axios from "axios"
import {installSliderType7} from "./sliders/type7"

$(document).ready(function() {

    const $btnShow = $(".js-show-more");

    $btnShow.each(function(){

        const $cardsWrap = $(this).siblings(".js-cards-wrap");
        let url = $(this).data("url"),
            paginator = $(this).data("paginator") || false;

        if(!paginator){
            paginator = "PAGEN_1";
        }

        $(this).on("click", function(){
            $("#pagination").attr("id", "old-pagination");

            let page = parseInt($(this).attr("data-page"));

            if(page < 1){
                page = 2;
            }

            let params = {
            };
            params[paginator] = page;

            axios({
                url: url,
                params: params,
                method: "get",
                headers: {
                    "Content-Type": "text/html; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                },
            }).then(res => {

                if (page + 1 > $(this).attr("data-max")) {
                    $(this).hide();
                } else {
                    $(this).attr("data-page", page + 1);
                }

                $cardsWrap.append(res.data);

                installSliderType7();

                $("#old-pagination").replaceWith($("#pagination"));
            }).catch(() => {
                alert("Что-то пошло не так...\nПопробуйте обновить страницу");
            });
        });
    });

});
